import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { generateDaysLeftString } from 'dateUtils';
import { ActiveSuggestedAction } from 'router/subrouters/DataRoom/models/Dashboard';
import {
  ACTIVE_SUGGESTION_ACTION,
  ACTIVE_SUGGESTION_DESCRIPTION,
  ACTIVE_SUGGESTION_TITLE,
} from 'router/subrouters/DataRoom/pages/Dashboard/componenets/SuggestedActions/data';
import useEnterpriseSuggestedActionNavigate from '../../hooks/useEnterpriseSuggestedActionNavigate';
import useEnterpriseThreeDotsOptions from '../../hooks/useEnterpriseThreeDotsOptions';
import SuggestedActionItemWrapper from 'components/SuggestedActionItemWrapper';

import './EnterpriseSuggestedActionItem.styles.scss';

type EnterpriseSuggestedActionItemProps = {
  className?: string;
  dataRoomId: string;
  dealRoomId?: string;
  suggestion: ActiveSuggestedAction;
};

const EnterpriseSuggestedActionItem: React.FC<
  EnterpriseSuggestedActionItemProps
> = (props) => {
  const { className, dataRoomId, dealRoomId, suggestion } = props;

  const { type, count, names, expiredAt } = suggestion;

  const title = ACTIVE_SUGGESTION_TITLE[type];
  const description = ACTIVE_SUGGESTION_DESCRIPTION[type];
  const action = ACTIVE_SUGGESTION_ACTION[type];

  const time = generateDaysLeftString(expiredAt);
  const secureLink = names?.[0];

  const { t } = useTranslation();

  const { isDissmising, isDontReminding, threeDotsOptions } =
    useEnterpriseThreeDotsOptions(dataRoomId, suggestion);

  const onAction = useEnterpriseSuggestedActionNavigate(
    dataRoomId,
    suggestion,
    dealRoomId,
  );

  const classes = classNames(
    'enterprise-suggested-action-item',
    { loading: isDissmising || isDontReminding },
    className,
  );

  return (
    <SuggestedActionItemWrapper
      className={classes}
      type={type}
      title={t(title, { count, secureLink, time })}
      description={t(description, { count, secureLink })}
      threeDotsOptions={threeDotsOptions}
      buttonContent={t(action, { count })}
      onButtonClick={onAction}
    />
  );
};

export default EnterpriseSuggestedActionItem;
